"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobile_component_1 = require("./mobile.component");
var use_media_query_string_hook_1 = __importDefault(require("../../hooks/use-media-query-string.hook"));
var responsive_util_1 = require("./responsive-util");
var desktopBreakPoint = responsive_util_1.incrementBreakPoint(mobile_component_1.breakpoint, 1);
exports.desktopBreakPointQuery = "(min-width: " + desktopBreakPoint + ")";
exports.Desktop = function (_a) {
    var children = _a.children;
    var isDesktop = use_media_query_string_hook_1.default(exports.desktopBreakPointQuery);
    return isDesktop ? children : null;
};
exports.Desktop.displayName = 'Desktop';
exports.default = exports.Desktop;
//# sourceMappingURL=desktop.component.js.map